import React, { useEffect, useState } from "react";
import { daysLeft } from "../lib/format";
import { Clock } from "lucide-react";

export default function Countdown({ isoDate, size = "md" }) {
    const [days, setDays] = useState(daysLeft(isoDate));
    useEffect(() => {
        const t = setInterval(() => setDays(daysLeft(isoDate)), 60000);
        return () => clearInterval(t);
    }, [isoDate]);

    if (days === null) return null;

    const urgent = days <= 2;
    const critical = days <= 1;
    const cls = critical ? "text-[var(--rl-urgent)]" : urgent ? "text-[#e2680d]" : "text-[var(--rl-text-2)]";
    const label = days === 0 ? "TODAY" : days === 1 ? "1 DAY LEFT" : `${days} DAYS LEFT`;
    const sizeCls = size === "sm" ? "text-[11px]" : "text-xs";
    return (
        <span className={`inline-flex items-center gap-1.5 font-semibold uppercase tracking-widest ${sizeCls} ${cls}`}>
            <Clock className="w-3 h-3" /> {label}
        </span>
    );
}
